import React from 'react';
import { Link } from 'react-router-dom';

// Compact clickable pill rendered in place of a brand name inside an
// assistant message. The pill links to the brand detail page so the
// chat can drive navigation without copying / pasting names.
function BrandChip({ id, name, hovercard }) {
  return (
    <span className="chat-brand-chip-wrap">
      <Link
        to={`/brands/${id}`}
        className="tag tag-accent-2 chat-brand-chip"
        title={hovercard || name}
      >
        {name}
      </Link>
      {hovercard ? (
        <span className="chat-brand-hovercard">{hovercard}</span>
      ) : null}
    </span>
  );
}

export default BrandChip;
